!((document, Drupal, $) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.marketMenu = {
    attach: function(context) {
      const $marketMenuContent = $('.market-menu__content', context);

      $marketMenuContent.each(function(index, content) {
        const contentItem = $(content);
        const defaultText = $(content).data('default-text');
        const hoverText = contentItem.data('text-hover');

        contentItem.on('mouseenter focusin', function() {
          contentItem.text(hoverText);
        });

        contentItem.on('mouseleave focusout', function() {
          contentItem.text(defaultText);
        });
      });
    }
  };
})(document, Drupal, jQuery);
